export default __webpack_public_path__ + "static/media/terr.1f1f7265.png";